import React, { FormEvent, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import Appbar from 'components/appbar/Appbar';
import InsideSaving from 'components/loading/InsideSaving';
import {
  ContentPad,
  PageShell,
  RecordFooter,
  RecordHeader,
  StyledForm,
  WorkArea,
} from 'components/record-shell/RecordShell';
import { api } from 'services/api';
import history from 'services/history';
import { AccessRule } from 'types/accessRule';
import AccessRuleForm from '../AccessRuleForm';
import { useAccessRuleValidation } from '../validation/accessRuleValidation';

const NewAccessRule: React.FC = () => {
  const [rule, setRule] = useState<AccessRule>({
    name: '',
    title: '',
    description: '',
    id: new Date().getTime(),
    access_rules: [],
  });
  const [validation, setValidation, validate] = useAccessRuleValidation();
  const [saving, setSaving] = useState(false);
  const [accessRules, setAccessRules] = useState<AccessRule[]>([]);

  useEffect(() => {
    api
      .get('/access-rules')
      .then(response => setAccessRules(response.data))
      .catch(err => console.error(err));
  }, []);

  function goBack() {
    history.push('/access-rules');
  }

  function handleChange<K extends keyof AccessRule>(index: K, value: AccessRule[K]) {
    setRule(oldValue => ({
      ...oldValue,
      [index]: value,
    }));
  }

  function handleSubmit() {
    setSaving(true);

    api
      .post('/access-rules', rule)
      .then(response => {
        toast.success('Regra cadastrada');
        // abre a regra recém-cadastrada
        history.push(response.data?.id ? `/access-rule/${response.data.id}` : '/access-rules');
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Não foi possível salvar a regra de acesso');
      })
      .finally(() => setSaving(false));
  }

  function handleValidation(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();
    setValidation({});

    validate(rule)
      .then(() => handleSubmit())
      .catch((err: yup.ValidationError) => {
        if (err instanceof yup.ValidationError) {
          setValidation({
            [err.path as string]: err.message,
          });
        }
      });
  }

  return (
    <>
      <Appbar title="Regras de acesso" backAction={goBack} />

      {saving && <InsideSaving />}

      <PageShell>
        <RecordHeader title="Nova regra de acesso" backAction={goBack} />

        <WorkArea>
          <ContentPad>
            <StyledForm onSubmit={handleValidation}>
              <AccessRuleForm
                accessRules={accessRules}
                handleChange={handleChange}
                accessRule={rule}
                validation={validation}
              />
              <button type="submit" style={{ display: 'none' }} />
            </StyledForm>
          </ContentPad>
        </WorkArea>

        <RecordFooter>
          <Button variant="contained" size="small" disabled={saving} onClick={() => handleValidation()}>
            Salvar regra
          </Button>
        </RecordFooter>
      </PageShell>
    </>
  );
};

export default NewAccessRule;
